import { createAction, props } from '@ngrx/store';
import { ConfirmType } from '@shared/enums/confirm-type';

export const confirmEmail = createAction(
  '[ConfirmEmail] confirmEmail',
  props<{ token: string; confirm_type: ConfirmType }>(),
);

export const confirmEmailSuccess = createAction('[ConfirmEmail] confirmEmail Success');

export const confirmEmailFailure = createAction('[ConfirmEmail] confirmEmail Failure', props<{ error: any }>());
